import "./App.css";
import Allroutes from "./Components/AllRoutes";
import Navbar from "./Components/Navbar";
import FooterMain from "./Footer/FooterMain";

function App() {
  return (
    <>
      <Navbar />
      <Allroutes />
      <FooterMain />
    </>
  );
}

export default App;
